import {defineStore} from 'pinia';
import {ModuleReceipt} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import receiptAPI from '@/apis/di/receiptAPI';
const receiptstore = new BaseDictionaryStore(receiptAPI);
export const useReceiptStore = defineStore(ModuleReceipt, {
  state: () => ({
    ...receiptstore.state,
    _config: {
      key: 'receipt_template_id',
      code: 'receipt_template_alias',
      name: 'receipt_type_name',
      table: 'di_receipt',
      quickFollow: 'active',
      moduleName: 'Mẫu số biên lai',
      defaultSort: 'receipt_template_alias',
    },
    moduleName: 'receipt',
  }),
  actions: {...receiptstore.action},
  getters: {
    ...receiptstore.getters,
  },
});
